import './InstagramShowcase.css';

const instagramUrl=(import.meta.env.VITE_MIELLEY_INSTAGRAM_URL||'').trim();
const fallback='https://www.instagram.com/';

const tiles=[
  {label:'MIELLEY',kind:'brand'},
  {label:'MOISSANITE',kind:'image',image:'/assets/instagram-v22/ring.webp',alt:'טבעת מוסונייט MIELLEY'},
  {label:'NEW DROP',kind:'image',image:'/assets/instagram-v22/necklace.webp',alt:'שרשרת MIELLEY'},
  {label:'JEWELRY',kind:'image',image:'/assets/instagram-v22/model.webp',alt:'תכשיטי MIELLEY על דוגמנית'},
  {label:'SPARKLE',kind:'image',image:'/assets/instagram-v22/bracelet.webp',alt:'צמיד טניס MIELLEY'},
  {label:'STYLE',kind:'image',image:'/assets/instagram-v22/earrings.webp',alt:'עגילי MIELLEY'},
] as const;

function InstagramIcon(){
  return <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="currentColor" strokeWidth="1.8"/>
    <circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" strokeWidth="1.8"/>
    <circle cx="17.4" cy="6.7" r="1.1" fill="currentColor"/>
  </svg>;
}

export function InstagramShowcase(){
  const href=instagramUrl||fallback;
  let handle='@MIELLEY';

  if(instagramUrl){
    try{
      const path=new URL(instagramUrl).pathname.split('/').filter(Boolean)[0];
      if(path)handle=`@${path}`;
    }catch{}
  }

  return <section className="mielley-instagram mielley-instagram-v22" dir="rtl" aria-label="MIELLEY Instagram">
    <div className="mielley-instagram-inner">
      <div className="mielley-instagram-gallery" aria-label="MIELLEY Instagram gallery">
        {tiles.map((tile,index)=>{
          const content=tile.kind==='brand'
            ? <div className="mielley-instagram-brand-tile" aria-hidden="true">
                <span>MIELLEY</span>
                <strong>M</strong>
                <i>LOOK EXPENSIVE. THINK SMART.</i>
              </div>
            : <>
                <img src={tile.image} alt={tile.alt} loading="lazy" decoding="async"/>
                <span className="mielley-instagram-tile-label">{tile.label}</span>
                <span className="mielley-instagram-tile-hover">Instagram <b>↗</b></span>
              </>;

          return <a
            key={`${tile.label}-${index}`}
            className={`mielley-instagram-tile ${tile.kind==='brand'?'is-brand':'is-image'}`}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${tile.label} — Instagram`}
          >{content}</a>;
        })}
      </div>

      <div className="mielley-instagram-copy">
        <span className="mielley-instagram-kicker">FOLLOW THE SPARKLE</span>
        <h2>הברק ממשיך <em>באינסטגרם.</em></h2>
        <p>לוקים חדשים, השקות, מוסונייט מקרוב והצצה ראשונה למה שבדרך.</p>

        <a className="mielley-instagram-cta" href={href} target="_blank" rel="noopener noreferrer">
          <span className="mielley-instagram-cta-icon"><InstagramIcon/></span>
          <span className="mielley-instagram-cta-copy">
            <strong>עקבו אחרינו באינסטגרם <b>↗</b></strong>
            <small dir="ltr">{handle}</small>
          </span>
        </a>
      </div>
    </div>
  </section>;
}
